import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'stripHashAndQuery' })
export class StripHashAndQueryPipe implements PipeTransform {
  constructor() {}

  transform(value: string): string {
    return value.split(/[?#]/)[0]
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/pipes/strip-hash-and-query.pipe.ts